import styled, { css } from 'styled-components';
import { makeStyles } from '@material-ui/core';
import { Body, colours, constants, Header } from '@cambridgeassessment/cambridge-ui';
import CheckIcon from '@material-ui/icons/Check';

interface ListItemProps {
  checked?: boolean;
}

const userInfoStyles = css`
  font-size: 16px;
  align-self: center;
  display: block;
  text-align: end;
`;

export const useStyles = makeStyles({
  checkedOption: {
    color: `${colours.scienceBlue}`,
  },
});

export const UserContainer = styled.div`
  display: flex;
  margin-right: 24px;
`;

export const StyledUserName = styled(Body)`
  ${userInfoStyles};
  font-weight: 600;
`;

export const StyledUserRole = styled(Body)`
  ${userInfoStyles}
  font-weight: bold;
`;

export const UserInfoContainer = styled.div`
  margin-right: 16px;
  align-self: center;
`;

export const StyledHeader = styled(Header)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 14px 0 rgba(206, 212, 217, 0.12), 0 5px 8px 0 rgba(206, 212, 217, 0.14),
    0 3px 5px -1px rgba(206, 212, 217, 0.2);
`;

export const LogoContainer = styled.div`
  margin-left: 40px;
  margin-right: 24px;
  cursor: pointer;
`;

export const PopoverContainer = styled.div`
  width: 365px;
`;

export const StyledListItem = styled.div<ListItemProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px;
  font-size: 16px;
  border-radius: 6px;

  &:hover {
    background-color: ${colours.alabaster};
    color: ${colours.scienceBlue};
    cursor: pointer;
  }

  background-color: ${(props) => (props.checked ? colours.alabaster : '')};
`;

export const LabelContainer = styled.div`
  font-size: 16px;
`;

export const RefContainer = styled.div`
  margin-top: 4px;
  margin-right: 70px;
`;

export const SingleRoleMargin = styled.div`
  margin-top: 5px;
`;

export const StyledContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const StyledBUSelectionContainer = styled.div`
  margin-left: 52px;
  text-align: end;
  font-family: ${constants.sourceSansPro};

  .MuiButton {
    &-text {
      font-size: 16px;
    }

    &-label {
      .MuiButton-endIcon {
        padding-top: 4px;
      }
    }
  }
`;

export const StyledBUContainer = styled.div`
  min-width: 150px;
  width: 100%;
`;

export const StyledCheckIcon = styled(CheckIcon)`
  margin-left: 15px;
`;
